import { Link } from '@tanstack/react-router';
import { HeroField } from './HeroField.tsx';

export function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero__visual" aria-hidden="true">
        <HeroField />
      </div>

      <div className="hero__plate">
        <div className="hero__col">
          <h1 className="hero__title" id="hero-title">
            <span className="line">
              <span className="w">Every robot.</span>
            </span>
            <span className="line">
              <span className="w">One operation.</span>
            </span>
          </h1>

          <p className="hero__lede">
            One execution layer between your WMS and every fleet on the floor.
          </p>

          <div className="hero__actions">
            <Link className="hero__cta" to="/contact">
              Book a floor assessment<span aria-hidden="true">↗</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
